import axiosApiInstance from 'utils/axios-instance'

export const clearCache = () => axiosApiInstance.get('cache/clear')

export const clearCacheByPrefix = prefix =>
  axiosApiInstance.get(`cache/clear/${prefix}`)
